import React from "react";
import { EducationType } from "../../../../school/constants/types";
import { IWizardConfig, SubmitButtonColor } from "../../../../wizard/types";
import { validator } from "../../../modals/updateStatus/validator";
import { Content } from "../../../modals/updateStatus/Content";
import { useApplicationQueries } from "../../../hooks/useApplicationQueries";
import { ApplicationStatus, ApplicationStatusText } from "../../../types";

const buttonColors = {
  [ApplicationStatus.PENDING]: SubmitButtonColor.Default,
  [ApplicationStatus.APPROVED]: SubmitButtonColor.Success,
  [ApplicationStatus.REJECTED]: SubmitButtonColor.Danger,
};

export function useChangeStatusConfig(
  applicationId: string,
  schoolType: EducationType,
): (status: ApplicationStatus) => IWizardConfig {
  const { updateApplicationStatus } = useApplicationQueries();

  return (status: ApplicationStatus) => ({
    steps: [
      {
        width: "552px",
        titleConfig: {
          titleText: `Changing status to "${ApplicationStatusText[status]}"`,
        },
        content: () => <Content status={status} />,
        validator: validator,
      },
    ],
    getInitialData: async () => ({
      injectedData: { status },
    }),
    saveCallback: (data) =>
      updateApplicationStatus(
        applicationId,
        {
          type: status,
          comment: data?.comment ?? "",
        },
        schoolType,
      ),
    submitButtonText: "Proceed",
    submitButtonColor: buttonColors[status],
    cancelButtonText: "Close",
  });
}
